import React, { MouseEvent, useCallback } from 'react';
import ClickableTableRow from "../../../../components/ClickableTableRow";
import { Checkbox, TableCell } from "@mui/material";
import { OfferMedium } from "../../../../../model/OfferMedium";
import PhotoUrlFactory from "../../../../../infrastructure/url-factory/PhotoUrlFactory";
import { NumberishId } from "../../../../../model/type";
import DataTableRowCells from "./DataTableRowCells";
import { CopyTextToClipboard } from "../../../../../action/copyTextToClipboard";
import { UpdateManyAvailabilities } from "../../../../../action/updateManyAvailabilities";

const DataTableRow: React.FC<DataTableRowProps> = props => {
    const { medium } = props;

    const onRowClick = useCallback((e: MouseEvent) => {
        props.onRowClick(medium.mediumId, e);
    }, []);

    return (
        <ClickableTableRow
            hover
            onClick={ onRowClick }
        >
            <TableCell>
                <Checkbox title='Zaznacz' checked={ props.selected }/>
            </TableCell>
            <DataTableRowCells
                medium={ medium }
                photoUrlFactory={ props.photoUrlFactory }
                copyTextToClipboard={ props.copyTextToClipboard }
                onEdit={ props.onEdit }
                updateManyAvailabilities={ props.updateManyAvailabilities }
            />
        </ClickableTableRow>
    );
}
export default React.memo(DataTableRow);

export interface DataTableRowProps {
    readonly medium: OfferMedium;
    readonly photoUrlFactory: PhotoUrlFactory;
    readonly selected: boolean;
    readonly onRowClick: (id: NumberishId, e: MouseEvent) => void;
    readonly copyTextToClipboard: CopyTextToClipboard;
    readonly onEdit: () => void;
    readonly updateManyAvailabilities: UpdateManyAvailabilities;
}